import React from "react";

import { ActiveGoal } from "@/features/member-profile/(care-plan)/components/GoalsAndObjectives/components/ActiveGoal";
import { Card, CustomForm, Text, TextTypes } from "@/component-library";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { getInterventionAndPlanFormErrors } from "@/features/notes/(v2)/helpers/intervention-and-plan-v2-form-helpers";
import { INTERVENTION_AND_PLAN_SCHEMA } from "@/features/notes/(v2)/constants/intervention-and-plan-v2-form-schema";

import { InterventionAndPlanNoteField } from "./InterventionAndPlanNoteField";

import "@/component-library/Link/styles.scss";
import "./MemberProfileGoalsAndObjectiveNoteDisplayV2.styles.scss";

// NOTE: This component is used in a number of spots: guided session and viewing notes from the
// patients chart
export function MemberProfileGoalsAndObjectiveNoteDisplayV2({
  draftView,
  editable,
  editHandler,
  goalAndObjectiveProgress,
  isCnaiEnabled,
  profileView,
}) {
  const renderForm = (formikProps) => {
    // always editing when the note is editable — no separate toggle needed
    const isEditingInternal = editable;

    return (
      <>
        <div className="MemberProfileGoalsAndObjectiveNoteDisplayV2--header">
          <Text
            className="MemberProfileGoalsAndObjectiveNoteDisplayV2--title"
            type={TextTypes.subtitle}
          >
            Care Goals & Objectives
          </Text>
        </div>

        {Object.keys(goalAndObjectiveProgress).map((goalNumber, index) => {
          const goal = goalAndObjectiveProgress[goalNumber];

          return (
            <>
              <div className="MemberProfileGoalsAndObjectiveNoteDisplayV2--goal_container">
                <ActiveGoal
                  className="MemberProfileGoalsAndObjectiveNoteDisplayV2--goal_view"
                  fieldsToHide={["objective_start_timestamp"]}
                  goal={goal}
                  hideObjectiveActions
                  key={goal.goal_id}
                />

                <div className="MemberProfileGoalsAndObjectiveNoteDisplayV2--form_container">
                  <Text type={TextTypes.label}>Interventions & Plans</Text>
                  <InterventionAndPlanNoteField
                    editable={editable}
                    editHandler={editHandler}
                    formikProps={formikProps}
                    goalNumber={goalNumber}
                    isCnaiEnabled={isCnaiEnabled}
                    isEditing={isEditingInternal}
                  />
                </div>
              </div>

              {/* hide hr for last element in the list */}
              {index !== Object.keys(goalAndObjectiveProgress).length - 1 && (
                <div className="InterventionAndPlanV2--hr" />
              )}
            </>
          );
        })}
      </>
    );
  };

  const getCardClassName = () => {
    if (profileView) {
      return "MemberProfileGoalsAndObjectiveNoteDisplayV2--profile_view_container";
    } else if (draftView) {
      return "MemberProfileGoalsAndObjectiveNoteDisplayV2--draft_view_container";
    }

    return "MemberProfileGoalsAndObjectiveNoteDisplayV2--guided_session_container";
  };

  return (
    <Card
      className={getCardClassName()}
      {...getAutomationDataAttr("MemberProfileGoalsAndObjectiveNoteDisplayV2_goalsDisplay")}
    >
      <CustomForm
        // NOTE: there is a validateOnMount parameter but this did not behave as expected
        // so we define an initial set of errors instead
        initialErrors={getInterventionAndPlanFormErrors(goalAndObjectiveProgress)}
        initialValues={{ ...goalAndObjectiveProgress, isEditingInternal: false }}
        render={renderForm}
        validateOnBlur={true}
        validateOnChange={true}
        validationSchema={INTERVENTION_AND_PLAN_SCHEMA}
      />
    </Card>
  );
}
